import React from 'react';

import { FormikReactSelectFormGroup } from '@shared/components/fields/formik/form_react_select_from_group';

import { client } from '@admin/libraries/apollo';
import { Coupon__FiltersInput, useCouponsQuery } from '@admin/schema';

export const FormikCouponSelectFormGroup: React.FC<{
  id: string;
  name: string;
  label: string;
  filters: Coupon__FiltersInput;
}> = ({ filters, ...props }) => {
  const { data, loading } = useCouponsQuery({
    client,
    variables: { filters },
  });

  const options =
    data?.result.map((coupon) => ({
      value: coupon.id,
      label: `${coupon.name} (${coupon.code})`,
    })) ?? [];

  return <FormikReactSelectFormGroup {...props} loading={loading} options={options} />;
};
